import { isDEVMODE } from '../_globals'
import Swiper, { Navigation } from 'swiper'
Swiper.use([Navigation])

export default class WknSwiper {

  constructor(el, navigation, options) {

    this.DOM = {
      el: el,
      navigation: navigation,
    }
    this.options = options

    this.init()

  }

  init() {

    if (isDEVMODE) console.log('New WknSwiper')

    this.createSwiper()
    this.addEvents()

  }

  createSwiper() {

    const { el = null, navigation = null } = this.DOM
    const { options = null } = this

    // Default Navigation
    let navigationOptions = false
    if (navigation) {
      navigationOptions = {
        nextEl: navigation.querySelector('.next'),
        prevEl: navigation.querySelector('.prev')
      }
    }

    this.swiper = new Swiper(el, {
      speed: 600,
      // spaceBetween: 40,
      // slidesPerView: 1,
      longSwipesRatio: 0.1,
      navigation: navigationOptions,
      ...options
    })

  }

  addEvents() {

    const { swiper } = this

    this.onStartDrag = this.onStartDrag.bind(this)
    swiper.on('touchStart', this.onStartDrag)

    this.onLeaveDrag = this.onLeaveDrag.bind(this)
    swiper.on('touchEnd', this.onLeaveDrag)
  }

  onStartDrag(swiper) {
    swiper.el.classList.add('--dragging')
  }

  onLeaveDrag(swiper) {
    swiper.el.classList.remove('--dragging')
  }

  destroy() {

    if (isDEVMODE) console.log('Destroy WknSwiper')

    const { swiper } = this

    swiper.off('touchStart', this.onStartDrag)
    swiper.off('touchend', this.onLeaveDrag)
    swiper.destroy()

  }
}
